import { cva } from 'class-variance-authority';

export const switchVariants = cva(
  [
    'data-[state=checked]:bg-color-comp-toggle-container-on-default',
    'data-[state=checked]:disabled:bg-color-comp-toggle-container-on-disabled',
    'data-[state=checked]:enabled:hover:bg-color-comp-toggle-container-on-hover',
    'data-[state=unchecked]:bg-color-comp-toggle-container-off-default',
    'data-[state=unchecked]:enabled:hover:bg-color-comp-toggle-container-off-hover',
    'data-[state=unchecked]:disabled:bg-color-comp-toggle-container-off-disabled',
    'group',
    'peer',
    'inline-flex',
    'shrink-0',
    'cursor-pointer',
    'items-center',
    'rounded-full',
    'p-[0.12rem]',
    'transition-colors',
    'focus-visible:outline',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-2',
    'focus-visible:outline-color-ref-ui-focus-default',
    // common lib overrides are giving the switch a default border on focus
    'focus:outline-none',
    'disabled:cursor-not-allowed',
  ],
  {
    variants: {
      size: {
        small: 'h-4 w-[1.625rem]',
        large: 'h-6 w-[2.375rem]',
      },
    },
    defaultVariants: {
      size: 'large',
    },
  },
);

export const thumbVariants = cva(
  [
    'bg-color-comp-toggle-on-container',
    'group-disabled:bg-color-comp-toggle-on-container',
    'pointer-events-none',
    'block',
    'rounded-full',
    'transition-transform',
    'group-disabled:opacity-30',
    'data-[state=unchecked]:translate-x-0',
    'drop-shadow-[2px_2px_2px_rgba(244,245,245,0.24)]',
  ],
  {
    variants: {
      size: {
        small: 'size-3 data-[state=checked]:translate-x-[0.65rem]',
        large: 'size-5 data-[state=checked]:translate-x-[0.88rem]',
      },
    },
    defaultVariants: {
      size: 'large',
    },
  },
);

export const switchLabelVariants = cva(
  [
    'ml-spacing-comp-toggle-gap',
    'peer-[:not(:disabled)]:cursor-pointer',
    'text-color-comp-toggle-label-strong',
    'peer-disabled:text-color-comp-toggle-label-disabled',
  ],
  {
    variants: {
      size: {
        small:
          'font-ref-caption-regular-font-family text-font-ref-caption-regular-font-size font-ref-caption-regular-font-weight leading-font-ref-caption-regular-line-height',
        large:
          'font-ref-caption-regular-font-family text-font-ref-caption-regular-font-size font-ref-caption-regular-font-weight leading-font-ref-caption-regular-line-height',
      },
    },
    defaultVariants: {
      size: 'large',
    },
  },
);
